export default __webpack_public_path__ + "static/media/pic01.a9bd76a7.jpg";